import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { KnownIssuePage } from 'src/app/model/page/group/known-issues/known-issue-table';
import { Banner } from 'src/app/model/shared/banner';
import { KnownIssuesPage } from 'src/app/model/shared/known-issues-page';
import { ApiService } from 'src/app/service/api.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-known-issues-jira-content-page',
  templateUrl: './known-issues-jira-content-page.component.html',
  styleUrls: ['./known-issues-jira-content-page.component.scss']
})
export class KnownIssuesJiraContentPageComponent implements OnInit {
  selectedItem: any;
  @Input() subscribeUrl: string = '';
  @Input() pageTitle: string = '';
  items: KnownIssuePage[] = [];
  banner: Banner = {} as Banner;
  KnownIssuesPage: KnownIssuesPage = {} as KnownIssuesPage;
  showDetailsPage: boolean = false;
  @Output() itemSelected = new EventEmitter<{ event: Event; item: any }>();

  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private sharedDataService: SharedDataService, private contentfulService: ContentfulService) { }

  setPageTitle(pageTitle: string) {
    if (pageTitle.length > 0) {
      this.pageTitle = pageTitle;
    }
    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'known-issues') {
        this.KnownIssuesPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'Known Issues' };

    this.contentfulService
      .getPageContentResponse(query)
      .then((knownIssuesPage) => {
        this.mapBanner(knownIssuesPage.includes.Entry);
        this.fetchJiraIssues();
      })
      .catch((error: any) => {
        console.error('Error fetching Contentful page content:', error.message);
      });
  }

  fetchJiraIssues(): void {
    this.apiService
      .sendGetRequest('/jira-issues')
      .then((response) => {
        if (response.success) {
          this.items = response.success as KnownIssuePage[];
        } else {
          throw new Error('Error fetching Jira issues: ' + response.error);
        }
      })
      .catch((error: any) => {
        console.error('Error fetching Jira issues:', error.message);
      });
  }

  private mapBanner(knownIssuesPageEntries: Entry<any>[]) {
    knownIssuesPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }
  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'];
    this.KnownIssuesPage.banner = {
      title: entry.fields['title'] as string,

      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      url: entry.fields?.['url'] as string,
      lastUpdated: entry.fields?.['lastUpdated'] as string
    };
  }
  displayErrorMsg(errorMsg: string | null | any[]): string {
    if (!errorMsg || (Array.isArray(errorMsg) && errorMsg.length === 0)) {
      return 'n/a';
    } else {
      return errorMsg as string;
    }
  }
  onSelectItem(event: Event, item: any) {
    event.preventDefault();
    this.selectedItem = item;
    this.itemSelected.emit({ event, item });
    this.showDetailsPage = true;
  }

  onBack() {
    this.showDetailsPage = false;
  }
}
